module.exports = __webpack_public_path__ + "media/images/emblems/Riaz-coat_of_arms-e37946edfe39a2e05ec117c0a45669fd.svg";